export default __webpack_public_path__ + "assets/models/3c7ccd4e3b382431f29dc08d4d771424.glb";